const PLATFORM_LINKS = ['Amazon'];

/**
 * Site footer with disclaimer and platform credits.
 */
const Footer = () => (
    <footer className="border-t border-slate-200 bg-white mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
            <div className="flex flex-col sm:flex-row items-center sm:items-start justify-between gap-6">
                {/* Brand */}
                <div className="flex flex-col items-center sm:items-start gap-2">
                    <div className="flex items-center gap-2">
                        <div
                            className="w-7 h-7 bg-gradient-to-br from-brand-600 to-violet-600 rounded-lg
              flex items-center justify-center"
                        >
                            <span
                                className="text-white text-sm"
                                aria-hidden="true"
                            >
                                ⚡
                            </span>
                        </div>
                        <span className="font-display font-extrabold text-slate-900 text-base">
                            DealsNDiscounts
                        </span>
                    </div>
                    <p className="text-xs text-slate-400 max-w-xs text-center sm:text-left leading-relaxed">
                        We earn a small commission on purchases made through our
                        affiliate links — at no extra cost to you. Deals are
                        regularly verified and updated.
                    </p>
                </div>

                {/* Platforms */}
                <div className="flex flex-col items-center sm:items-end gap-2">
                    <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                        Platforms
                    </p>
                    <div className="flex flex-wrap gap-2 justify-center sm:justify-end">
                        {PLATFORM_LINKS.map((p) => (
                            <span
                                key={p}
                                className="text-xs text-slate-500 bg-slate-100 px-2.5 py-1 rounded-full font-medium"
                            >
                                {p}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-100 text-center text-xs text-slate-300">
                © {new Date().getFullYear()} DealsNDiscounts. All rights
                reserved.
            </div>
        </div>
    </footer>
);

export default Footer;
